// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @08.08.2019 07:18:41
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class Interval_abstract extends PersistentObject {
  static $t: string = 'SagaBase.Interval';
  $t: string = 'SagaBase.Interval';

  public static GetMembers(): string[] {
    return ['StartTimeUtc', 'EndTimeUtc'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return Interval_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    this.StartTimeUtc = this.StartTimeUtc && new Date(this.StartTimeUtc);
    this.EndTimeUtc = this.EndTimeUtc && new Date(this.EndTimeUtc);

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public StartTimeUtc: Date = new Date();
  public EndTimeUtc: Date = new Date();

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
